module.exports = __webpack_public_path__ + "img/picto-home.bb105849.svg";